import EServiceEngineerActions from '@r1-frontend/service-engineer-visit/constants/actions';
import { IAction } from '@r1-frontend/service-engineer-visit/reducer/reducer';

const requestSlots = (days: number): IAction<EServiceEngineerActions.REQUEST_SLOTS, { days: number }> => ({
    type: EServiceEngineerActions.REQUEST_SLOTS,
    payload: { days },
});

export default requestSlots;
